import axios from "axios";
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { Config } from "../Config";
import { secureDB } from "../secureStorage";

import { getAccessToken, getAccountNames, getFeatureConfigs, getInsurancesList, getLocationNames, getMessageTemplatesData, getPracticeInfo, getRefreshToken, getSelectedSpeciality, setAccessToken, setRefreshToken } from "../Session";

export const generateAppointmentTableData = (data) => {
  
  const tableData = data.map((item) => {
    return {
      id: item.id,
      practiceId: item.practice_id,
      checked: false,
      firstName: item.first_name,
      lastName: item.last_name,
      avatarImgUrl: "/images/avatar.png",
      date: item.date_of_birth,
      gender: item.gender,
      phoneNumber: usPhoneFormat(item.phone),
      insuranceName: item.insurance,
      // insuranceImgUrl: item.insurance_id_card_url,
      // insuranceImgUrl: "/images/avatar_1.png",
      visited: item.last_visit,
      status: item.status,
      location: item.location,
      locationId: item.location_id,
      appointmentTime: item.appointment_time,
      appointmentDate: item.appointment_date,
      specialty: item.specialty || "-",
      accountName: account_name(item?.account_id),
      ...item,
    };
  });
  return tableData;
};

export const generateBookAppointmentTableData = (data) => {
  
  const tableData = data.map((item) => {
    return {
      id: item.id,
      practiceId: item?.location?.practice_id,
      checked: false,
      firstName: item?.first_name,
      lastName: item?.last_name,
      avatarImgUrl: "/images/avatar.png",
      dob: item?.dob,
      gender: item?.gender,
      phoneNumber: usPhoneFormat(item?.phone),
      insuranceName: item?.insurance_name,
      insuranceId: item?.insurance_id,
      visited: item?.last_visit,
      status: item?.status,
      location: item?.location,
      locationId: item?.location_id,
      appointmentTime: item?.appointment_time,
      appointmentDate: item?.preferred_date_1,
      specialty: item?.specialty || "-",
      accountName: account_name(item?.account_id),
      ...item,
    };
  });
  return tableData;
};

export const generateRevenueTableData = (data) => {  
  
  const tableData = data.map((item) => {
    return {
      id: item.id,
      practiceId: item.practice_id,
      locationId: item.location_id,
      checked: false,
      firstName: item.first_name,
      lastName: item.last_name,
      avatarImgUrl: "/images/avatar.png",
      birthDate: item.dob,
      phoneNumber: item.mobile_phone === null
      ? usPhoneFormat(item.home_phone)
      : usPhoneFormat(item.mobile_phone),
      insuranceName: item.insurance_name,
      visitYear: item.visit_year,
      numberOfVisits: item.encounters,
      totalPayment: item.payments,
      averageRevPerVisit: item.average_revenue,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
      ...item,
    };
  });
  return tableData;
};

export const generateTableData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      checked: false,
      firstName: item.first_name,
      lastName: item.last_name,
      avatarImgUrl: "/images/avatar.png",
      date: item.date_of_birth,
      gender: "Male",
      phoneNumber: item.phone,
      insuranceName: item.insurance,
      // insuranceImgUrl: item.insurance_id_card_url,
      visited: item.last_visit,
      status: item.status,
      location: item.location,
      appointmentTime: item.appointment_time,
      appointmentDate: item.appointment_date,
      specialty: item.specialty || "-",
    };
  });
  return tableData;
};


export const generatePatientTableData = (data) => {
  const tableData = data?.map((item) => {
    return {
      id: item.id,
      practiceId: item.account_id,
      firstName: item.first_name,
      lastName: item.last_name,
      dob: item.dob,
      age: item.age,
      sex: item.sex === "M" ? "Male" : item.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.mobile_phone === null
          ? usPhoneFormat(item.home_phone)
          : usPhoneFormat(item.mobile_phone),
      insuranceName: item.insurance_name,
      avatarImgUrl: "/images/avatar.png",
      lastVisit: item.last_visit,
      riskLevel: item.risk_level,
      preventativeDue: item.preventative_due,
      insuranceID: item.insurance_code,
      patientID: item?.id,
      address: item?.address,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
      chronicConditions: item?.has_chronic_conditions,
      zip_code: item?.zip,
      ...item,
    };
  });
  return tableData;
};
export const generateCCMPatientTableData = (data) => {
  const tableData = data?.map((item) => {
    return {
      id: item.id,
      practiceId: item.account_id,
      firstName: item.first_name,
      lastName: item.last_name,
      dob: item.dob,
      age: item.age,
      sex: item.sex === "M" ? "Male" : item.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.mobile_phone === null
          ? usPhoneFormat(item.home_phone)
          : usPhoneFormat(item.mobile_phone),
      insuranceName: item.insurance_name,
      riskLevel: item.risk_level,
      avatarImgUrl: "/images/avatar.png",
      insuranceID: item.insurance_code,
      createdAt: item.created_at,
      recordingDuration: item.recording_duration,
      recordingUrl: item.recording_url,
      patientID: item?.id,
      address: item?.address,
      transcription: item?.transcription,
      transcriptionSummary: item?.transcription_summary,
      transcriptionSummaryJSON: item?.transcription_summary_json,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
      ...item,
    };
  });
  return tableData;
};

export const calculateAgeFromDOB = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

export const  convertSecondsToTime = (seconds) =>{
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0 || minutes > 0) {
    return `${hours > 0 ? hours + " hour, " : ""}${
      minutes > 0 ? minutes + " min, " : ""
    }${remainingSeconds} sec`;
  } else {
    return `${remainingSeconds} sec`;
  }
}

export const generateOrderTableData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      patientId: item.patient_id,
      medmoPatientId: item.medmo_patient_id,
      medmoOrderId: item.medmo_order_id,
      medmoPrescriberId: item.medmo_prescriber_id,
      prescriberId: item.prescriber_id,
      medmoLocationId : item.medmo_location_id,
      locationId : item.location_id,
      medmoScanId : item.medmo_scan_id,
      icd10 : item.icd10,
      examReason : item.exam_reason,
      schedulingNotes : item.scheduling_notes,
      additionalNotes : item.additional_notes,
      insurancePlan : item.insurance_plan,
      policyNumber : item.policy_number,
      groupNumber : item.group_number,
      zipcode : item.zipcode,
      firstName : item.first_name,
      lastName : item.last_name,
      location : item.location_name,
      status : item.status

    };
  });
  return tableData;
};

export const generateMessageTableData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      notificationType: item.notification_type,
      receiverAddress: item.receiver_address,
      messageBody: item.message_body,
      status: htmlStatus(item.status),
      raw_status: item.status,
      segment: countSegments(item.message_body),
      createdAt: usDate(item.created_at, true, false),
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id)
    };
  });
  return tableData;
};

export const generateLetterTableData = (data) => {
  const tableData = data?.map((item) => {
    return {
      id: item.id,
      notificationType: item.letter_type,
      // receiverAddress: item.receiver_address,
      messageBody: item.message,
      status: "Delivered",
      createdAt: usDate(item.created_at, true, false),
    };
  });
  return tableData;
};

export const generateMessageTemplateTableData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      templateName: item.title,
      templateType: item.template_type,
      messageBody: item.body,
      segment: countSegments(item.body),
      createdAt: usDate(item.created_at, true, false),
    };
  });
  return tableData;
};

// US phone format function
export const usPhoneFormat = (phone) => {
  if (phone?.includes('+1')) {
    phone = phone?.replace('+1', '');
  }

  const cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phone;
};

// US phone format function
export const usPhoneFormatValid = (phoneNumber) => {
  phoneNumber = phoneNumber.replace(/[^0-9+]+/g, '');
  if (phoneNumber.includes('+1')) {
    phoneNumber = phoneNumber.replace('+1', '');
  }
  if (phoneNumber.length !== 10) {
    return null;
  }
  return phoneNumber;
};

// US date format function
export const usDate = (dateString, isTime = false, UTC = true) => {

  const date = new Date(dateString);
  if (isNaN(date.getTime()) || dateString === null) {
    return "";
  }
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: isTime ? "2-digit" : undefined,
    minute: isTime ? "2-digit" : undefined,
    second: isTime ? "2-digit" : undefined,
    hour12: isTime
  };
  if (UTC) { 
    options.timeZone = "UTC";
  }  

  const formattedDate = date.toLocaleDateString("en-US", options);

  return isTime ? formattedDate.replace(",", "") : formattedDate;
};

// Only use DatePicker
export const datePickerFormat = (value) => {
  if (value == null || value.length < 8) {
    return value;
  }
  const dateString = value.toString();
  const Parts = dateString.split(" ");
  const keepOnlyDate = Parts.slice(0, 4).join(" ");
  
  const parts = keepOnlyDate.split(" ");
  const monthMap = {
    "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04", "May": "05", "Jun": "06",
    "Jul": "07", "Aug": "08", "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
  };
  const formattedDate = `${monthMap[parts[1]]}/${parts[2]}/${parts[3]}`;
  return formattedDate
  
  // const parsedDate = new Date(keepOnlyDate);
  // value = parsedDate.toLocaleDateString("en-US", {
  //   month: "2-digit",
  //   day: "2-digit",
  //   year: "numeric",
  // });
  // return value; 
};

// Exchange Date yyyy-mm-dd to mm/dd/yyyy
export const exchangeDate = (value) => {
  if (value == null || value.length < 8 || !value.includes('-')) {
    return value;
  }

  const parts = value.split('-'); // Split input string by '-'
  const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
  return formattedDate;
};

export const adjustDateTime = (dateTimeString) => {
  var date = new Date(dateTimeString);
  var gmtOffsetMinutes = date.getTimezoneOffset();    
  var hours = Math.abs(Math.floor(gmtOffsetMinutes / 60));
  var minutes = Math.abs(gmtOffsetMinutes % 60);
  var gmtOffsetString = (gmtOffsetMinutes < 0 ? "+" : "-") + hours.toString().padStart(2, '0') + minutes.toString().padStart(2, '0');
  var sign = gmtOffsetString.charAt(0) === '-' ? -1 : 1;
  var offsetHours = parseInt(gmtOffsetString.substr(1, 2), 10);
  var offsetMinutes = parseInt(gmtOffsetString.substr(3, 2), 10);
  date.setHours(date.getHours() + sign * offsetHours);
  date.setMinutes(date.getMinutes() + sign * offsetMinutes);
  var formattedDateTime = date.toLocaleString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit', 
    hour: '2-digit', 
    minute: '2-digit', 
    second: '2-digit', 
    hour12: true 
  }).replace(',', '');

  return formattedDateTime;
}

export const addUTCMin = (utcTimeString) => {
  const [datePart, timePart] = utcTimeString.split('T');
  const [time, milliseconds] = timePart.split('.');
  const [hours, minutes, seconds] = time.split(':').map(Number);

  const totalMinutes = hours * 60 + minutes + 10;
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;

  const newTimePart = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}:${seconds}`;
  const newUTCString = `${datePart}T${newTimePart}.${milliseconds || '000'}Z`;

  return newUTCString;
}

export const getTableIdToContents = (class_names, selectedRows) => {
  // Map over selected rows to retrieve data from corresponding table cells
  const rowData = selectedRows.map((row) => {
    // Get the elements corresponding to the current row
    const elements = document
      .getElementsByClassName("row_" + row)[0]
      .getElementsByTagName("td");
    // Extract data from cells with specified class names
    const data = Array.from(elements)
      .filter((td) => td.classList.contains(class_names))
      .map((td) => td.textContent.trim());
    return data; // Return data for the current row
  });
  return rowData; // Return array containing data for all selected rows
};

// HTML status function
export const htmlStatus = (status) => {
  switch (status) {
    case "Delivered":
      return <span className="docpro_badge docpro_badge_success">{status}</span>;
    case "Failed":
      return <span className="docpro_badge docpro_badge_danger">{status}</span>;
    case "Queued":
      return <span className="docpro_badge docpro_badge_info">{status}</span>;
    case "Scheduled":
      return <span className="docpro_badge docpro_badge_schedule">{status}</span>;
    case "Insufficient Credits":
      return <span className="docpro_badge docpro_badge_pending">{status}</span>;
    case "Invalid Phone":
      return <span className="docpro_badge docpro_badge_danger">{status}</span>;
    default:
      return <span className="docpro_badge">{status}</span>;
  }
};

// Count segments function
export const countSegments = (text) => {
  const GSM7_BASIC =
    "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
  const GSM7_EXT = { "^":1,"{":1,"}":1,"\\":1,"[":1,"~":1,"]":1,"|":1,"€":1 };

  const isGsmBasic = ch => GSM7_BASIC.indexOf(ch) !== -1;
  const isGsmExt   = ch => ch in GSM7_EXT;

  let gsmSeptets = 0;
  let requiresUcs2 = false;
  let nonGsmSet = new Set();

  // count GSM septets or mark UCS-2
  for (let i = 0; i < text.length; i++) {
    const code = text.charCodeAt(i);
    if (code >= 0xD800 && code <= 0xDBFF) { // surrogate pair → emoji
      nonGsmSet.add(text[i] + (text[i+1] ?? ""));
      i++;
      requiresUcs2 = true;
      continue;
    }
    const ch = text[i];
    if (isGsmBasic(ch)) gsmSeptets += 1;
    else if (isGsmExt(ch)) gsmSeptets += 2;
    else {
      nonGsmSet.add(ch);
      requiresUcs2 = true;
    }
  }

  const encoding = requiresUcs2 ? "UCS-2" : "GSM-7";
  let lengthUnits, perSegmentLimit;

  if (encoding === "UCS-2") {
    // Twilio counts newline as CRLF = 2 units
    let extraForCrLf = 0;
    for (let i = 0; i < text.length; i++) {
      if (text[i] === "\n" && text[i - 1] !== "\r") extraForCrLf++;
    }
    lengthUnits = text.length + extraForCrLf;
    perSegmentLimit = lengthUnits <= 70 ? 70 : 67;
  } else {
    lengthUnits = gsmSeptets;
    perSegmentLimit = lengthUnits <= 160 ? 160 : 153;
    nonGsmSet = new Set();
  }

  const segments = Math.ceil(lengthUnits / perSegmentLimit) || 1;
  return segments;
  // const remainingInLast = (segments * perSegmentLimit) - lengthUnits;

  // 🔍 Debug details
  // console.log("---- SMS Segment Debug ----");
  // console.log("Encoding:", encoding);
  // console.log("Text length (raw):", text.length);
  // console.log("Extra CRLF count:", encoding === "UCS-2" ? lengthUnits - text.length : 0);
  // console.log("Total counted length:", lengthUnits);
  // console.log("Per segment limit:", perSegmentLimit);
  // console.log("Segments:", segments);
  // console.log("Remaining in last:", remainingInLast);
  // if (nonGsmSet.size) console.log("Non-GSM chars:", Array.from(nonGsmSet).join(" "));

  // return {
  //   encoding,
  //   segments,
  //   perSegment: perSegmentLimit,
  //   remainingInLast,
  //   length: lengthUnits,
  //   nonGsmChars: Array.from(nonGsmSet)
  // };
}

// Notification function
export const notify = (
  type = "success",
  message = "",
  visibleTimeInSeconds = 2,
  message2 = ""
) => {
  let waitTime = visibleTimeInSeconds * 1000;
  const options = {
    position: "top-center",
    autoClose: waitTime,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    transition: Slide,
    closeButton: true,
  };

  // Custom content with header and body
  const content = (
    <div>
      {message2 ? (
        <>
          <b>{message}</b>
          <div style={{ lineHeight: '19px', fontSize: '13.5px', marginTop: '5px' }}>{message2}</div>
        </>
      ) : (
        <div>{message}</div>
      )}
    </div>
  );

  if (type === "success") {
    toast.success(content, { ...options, className: 'custom-toast-success' });
  } else if (type === "error") {
    toast.error(content, { ...options, className: 'custom-toast-error' });
  } else if (type === "info") {
    toast.info(content, { ...options, className: 'custom-toast-info' });
  } else if (type === "warning") {
    toast.warning(content, { ...options, className: 'custom-toast-warning' });
  } else {
    toast.error(content, { ...options, className: 'custom-toast-error' });
  }
};

export const formatDate = (date) => {
  if (!date) return "";

  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }

  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  if (isNaN(date.getTime())) {
    return "";
  }

  let year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const now = new Date();
const options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

// Use Intl.DateTimeFormat to get the parts of the date
const formatter = new Intl.DateTimeFormat("en-US", options);
const parts = formatter.formatToParts(now);

// Create a formatted date string in 'YYYY-MM-DD' format
const newYorkTime = `${parts.find(part => part.type === 'year').value}-${parts.find(part => part.type === 'month').value}-${parts.find(part => part.type === 'day').value}`;

export { newYorkTime };

export const getDateString = () => {
  const getConfigTimeZone = Config.timeZone;
  if(getConfigTimeZone === "local") {
    const date = new Date().toLocaleDateString('en-CA');
    return date;
  } else {
    return newYorkTime;
  }
};

export const convertTo12HourFormat = (time) => {
  // Assuming time is in the format 'HH:MM:SS.ssssss'
  const [hours, minutes] = time.split(":");

  // Create a new Date object with the hours and minutes
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  // Get the hours in 12-hour format
  const hours12 = date.getHours() % 12 || 12;

  // Get the minutes
  const minutesPadded = date.getMinutes().toString().padStart(2, "0");

  // Get 'AM' or 'PM'
  const period = date.getHours() < 12 ? "AM" : "PM";

  return `${hours12}:${minutesPadded} ${period}`;
};

export const convertDateWithSlash = (date) => {
  if (!date) return "";
  // return `${new Date(date).getMonth() + 1}/${new Date(
  //   date
  // ).getDate()}/${new Date(date).getFullYear()}`;
  const newDate = new Date(date);
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const day = newDate.getDate().toString().padStart(2, '0');
  const year = newDate.getFullYear();

  return `${month}/${day}/${year}`;
};
export const generatePatienCareGaptTableData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      practiceId: item.practice_id,
      firstName: item.first_name,
      lastName: item.last_name,
      dob: usDate(item.dob, false),
      sex: item.sex === "M" ? "Male" : item.sex === "F" ? "Female" : "Other",
      mobilePhone: usPhoneFormat(item.mobile_phone),
      insuranceName: item.insurance_name,
      avatarImgUrl: "/images/avatar.png",
      insuranceId: item.insurance_id,
      care_gaps: item.care_gaps,
      age: item.age,
      chronic_conditions: item.chronic_conditions,
      insurance_code: item.insurance_code,
      lastVisit: exchangeDate(item.last_visit),
      address: item.address,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
      zip_code: item?.zip
    };
  });
  return tableData;
};

export const convertTimeToISOString = (timeString, dateParam) => {
  if (!timeString) return "";
  // Create a new Date object
  const date = new Date(dateParam);

  // Split the time string into hours and minutes
  const [time, period] = timeString.split(" ");
  const [hours, minutes] = time.split(":");

  // Convert the hours to 24-hour format if the period is PM
  const hours24 =
    period.toUpperCase() === "PM" ? parseInt(hours) + 12 : parseInt(hours);

  // Set the hours and minutes on the date
  date.setHours(hours24, minutes);

  // Return the time in the format "13:06:15.327Z"
  return date.toISOString().split("T")[1];
};

export const generateWaitingRoomData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      patientId: item.patient_id,
      accountId: item.account_id,
      locationId: item.location_id,
      checked: false,
      firstName: item.first_name,
      lastName: item.last_name,
      date: item.dob,
      avatarImgUrl: "/images/avatar.png",
      gender: item.sex === "M" ? "Male" : item.sex === "F" ? "Female" : "Other",
      insuranceName: item.insurance_name,
      // insuranceImgUrl: "/images/avatar_1.png",
      visiteType: "DOT physical",
      lastVisit: item.last_visit,
      pendingMeasures: item.care_gap,
      dos: item.dos,
      isPrint: item.is_print,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
      mobilePhone: item.mobile_phone === null
        ? usPhoneFormat(item.home_phone)
        : usPhoneFormat(item.mobile_phone),
      chronicConditions: (item?.chronic_conditions_count > 0) ? true : false,
      ...item,
    };
  });
  return tableData;
};

export const getInitials = (name) => {
  if (!name) return "";
  const words = name.replace(/\s+/g, ' ').split(" ");
  // Map each word to its first character, convert to uppercase, and join together
  const initials = words.map((word) => word[0]?.toUpperCase()).join("");

  return initials;
};

export const generateReviewData = (data) => {
  const tableData = data.map((item) => {
    return {
      id: item.id,
      checked: false,
      firstName: item.first_name,
      lastName: item.last_name,
      avatarImgUrl: "/images/avatar.png",
      dateOfBirth: item.date_of_birth,
      phoneNumber: item.phone_number || "",
      // insuranceImgUrl: "/images/avatar_1.png",
      ...item,
    };
  });
  return tableData;
};

export const careGapsLatestCompletedDos = (careGaps) => {
  try {
    // Filter the care gaps to find the ones with status "completed"
    const completedCareGaps = careGaps.filter(careGap => careGap.status === 'completed');

    // Sort the completed care gaps by dos in descending order
    completedCareGaps.sort((a, b) => new Date(b.dos) - new Date(a.dos));

    // If there are completed care gaps, return the dos of the latest one
    if (completedCareGaps.length > 0) {      
      return completedCareGaps[0].dos;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export const localData = (keyName, isRemove = false) => {
  if (isRemove === false) {
    const isLocalDataExists = localStorage.getItem(keyName) !== null;
    if (isLocalDataExists) {
      const storedLocalData = localStorage.getItem(keyName);
      try {
        return JSON.parse(storedLocalData);
      } catch (error) {}
      return storedLocalData;
    } else {
      return null;
    }
  } else {
    try {
      keyName.forEach((key) => {
        localStorage.removeItem(key);
      });
    } catch (error) {}
    return true;
  }
};

export const getSecureData = async (keyName, isRemove = false) => {
  if (isRemove === false) {
    return await secureDB.getItem(keyName);
  } else {
    try {
      await secureDB.removeItems(keyName);
    } catch (error) {}
    return true;
  }
};

export const getSecureDataPropertyValue = async (keyName, propertyKey) => {  
  return await secureDB.getItemValue(keyName, propertyKey);  
};

export const userMessageTemplates =  () => {
  return getMessageTemplatesData();
};

export const setSecureData = async (keyName, value) => {
  await secureDB.setItem(keyName, value);
  return true;
};

export const removeSecureItem = async (keyName) => {
  try {
    await secureDB.removeItem(keyName);
  } catch (error) {}
  return true;
};
export const removeSecureItems = async (keyList) => {
  try {
    await secureDB.removeItems(keyList);
  } catch (error) {}
  return true;
};

export const resetSecureData = async (force = false) => {
  await secureDB.clear(force);
  return true;
};

export const postData = async (url, setData, input) => {
  try {    
    const headers = {
        "Content-Type": "application/json",
        "accept": "application/json",
        "Authorization": `Bearer ${userAccessToken()}`,
      }
    const response = await axios.post(url, input, { headers });
    if (response.status === 200) {
      if (setData === true) {
        return response.data;
      } else {
        setData(response.data);
      }      
    }
  } catch (error) {
    console.error(`Error fetching data from ${url}:`, error);
  }
};

export const Gender = (gender) => {

  switch(gender?.toUpperCase()) {
   case 'M':
    return 'Male';
   case 'F':
    return 'Female';
   case 'A':
    return 'Another';
   default:
    return 'Others';
 }
};

export const getPractice = (key_name) => {  
  
  const practiceInfo = getPracticeInfo();
  
  // if (practiceInfo == null) {
  //   const url = window.location.origin + "/";
  //   if (window.location.href !== url) {
  //     window.location.href = url;
  //   }
  // }
  return practiceInfo ? practiceInfo[key_name] || 0 : 0; 
  
};

export const userAccessToken = () => {  
  return getAccessToken();
};

export const userRefreshToken = () => {
  return getRefreshToken();
};

export const getSpeciality = () => {
  return getSelectedSpeciality();
};


// Function to format number with commas
export const numberWithCommas = (number) => {
  return number?.toLocaleString();
};

// Auth
export const auth = () => {
  const token = userAccessToken();
  if(token){
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  }
};

export const role_count = () => {
  const user = auth();
  return user?.realm_access?.roles?.length;
}

export const role_has = (role) => {
  const user = auth();
  return user?.realm_access?.roles?.includes(role) ? role : null;
}

export const audit_file = () => {
  const user = auth();
  return user?.audit_file ? user?.audit_file : `${Config.appUrl}/pdf/DocPro.pdf`;
}

export const handelCopyLink =  async (link, type="") => {
  if(link === ''){
    return notify('error', 'Something went wrong');
  } else {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = link;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
    if(type === "text") {
      return notify('success', 'Text copied!', 0.5);
    } else {
      return notify('success', 'Link copied!', 0.5);
    }
  }
}

export const clearLocalStorageExcept = async () => {  
  setAccessToken(null);
  setRefreshToken(null);
  await secureDB.clear();
  
  // const exceptKeys = ['practice_insurances'];
  // const keysToKeep = new Set(exceptKeys);
  // const allKeys = Object.keys(localStorage);
  
  // for (const key of allKeys) {
  //   if (!keysToKeep.has(key)) {
  //     localStorage.removeItem(key);
  //   }
  // }
}

export const dev_only = () => {
  if(Config.appUrl === 'https://app.doc.pro') {
    return false;
  } else {
    return true;
  }
}

export const caregap_name = (id) => {
  const caregaps_name = {
    "1": "Diabetes Eye Exam",
    "2": "Diabetes A1c",
    "3": "Fall Risk Screening",
    "4": "Blood Pressure",
    "5": "Cervical Cancer Screening",
    "6": "Chlamydia Screening",
    "7": "Colorectal Cancer Screening",
    "8": "Depression Screening",
    "9": "Breast Cancer Screening",
    "10": "HIV Screening",
    "11": "Tobacco Screening",
    "12": "Dementia",
    "13": "Annual Physical Examination",
    "14": "Care of Older Adult",
    "15": "Flu Shots",
    "16": "Antidepressant Medication Management",
    "17": "Child and Adolescent Well-Care Visits",
    "18": "Childhood Immunization Status",
    "19": "ED F/U for Mental Illness",
    "20": "ED F/U for Substance Use",
    "21": "High Intensity Care F/U for Substance Use",
    "22": "Hospitalization F/U for Mental Illness",
    "23": "Immunizations for Adolescents",
    "24": "Kidney Health Evaluation for Patients With Diabetes",
    "25": "Postpartum Care",
    "26": "Timeliness of Prenatal Care",
    "27": "Well Child Visits"
  };

  return caregaps_name[id] || "";
}

export const schedule_text = {
    "patient_not_visited": "Dear patient, it’s time for your yearly checkup. It is essential for your health. Please schedule an appointment.",
    "patient_lab_report": "Dear patient, it’s time for lab report follow up. It is essential to discuss your lab report. Please schedule an appointment.",
    "patient_high_risk": "Dear patient, it’s time for your monthly visit for chronic care management. It is essential for your health. Please schedule an appointment.",
    "patient_annual_wellness": "Dear patient, it’s time for your annual wellness visit. Please schedule an appointment."
};
  
// Function to sort data: first by status (completed first), then by name
export const sortCaregapsData = (data) => {
  // Check if data is not an array, return empty array if invalid
  if (!Array.isArray(data)) {
    return [];
  }
  return data.sort((a, b) => {
    // Compare status: completed first
    if (a.status === "completed" && b.status === "pending") return -1;
    if (a.status === "pending" && b.status === "completed") return 1;
    // If statuses are the same, sort by name
    return a.name.localeCompare(b.name);
  });
};

export const generateAdvancedDirectiveTableData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.dob,
      // sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.option2_tel_no === null
          ? usPhoneFormat(item?.option2_tel_no)
          : usPhoneFormat(item?.option2_tel_no),
      avatarImgUrl: "/images/avatar.png",
      lastVisit: item?.dos,
      address: item?.address,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generateHipaaConsentTableData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.dob,
      mental_info: item?.mental_info,
      avatarImgUrl: "/images/avatar.png",
      lastVisit: item?.dos,
      address: item?.address,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generateOlderCareTableData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.patient_dob,
      sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      avatarImgUrl: "/images/avatar.png",
      lastVisit: item?.dos,
      painLocation: item?.pain_location,
      assignmentDate: item?.patient_assessment_date,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generatePatientIntakeTableData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.dob,
      sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.cell_num === null
          ? usPhoneFormat(item?.cell_num)
          : usPhoneFormat(item?.cell_num),
      avatarImgUrl: "/images/avatar.png",
      address: item?.address,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generatePatientSurveyData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.dob,
      sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.cell_num === null
          ? usPhoneFormat(item?.cell_num)
          : usPhoneFormat(item?.cell_num),
      avatarImgUrl: "/images/avatar.png",
      visitDate: item?.visit_date,
      provider: item?.provider,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generateDotPhysicalData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.info_first_name,
      lastName: item?.info_last_name,
      dob: item?.info_dob,
      sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.info_phone === null
          ? usPhoneFormat(item?.info_phone)
          : usPhoneFormat(item?.info_phone),
      avatarImgUrl: "/images/avatar.png",
      email: item?.info_email,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const generateImmunizationData = (data) => {
  const tableData = data?.map((item) => {
    
    return {
      id: item?.id,
      practiceId: item?.account_id,
      firstName: item?.first_name,
      lastName: item?.last_name,
      dob: item?.birth,
      sex: item?.sex === "M" ? "Male" : item?.sex === "F" ? "Female" : "Other",
      mobilePhone:
        item.phone === null
          ? usPhoneFormat(item?.phone)
          : usPhoneFormat(item?.phone),
      avatarImgUrl: "/images/avatar.png",
      provider: item?.ins_provider,
      accountName: account_name(item?.account_id),
      locationName: location_name(item?.location_id),
    };
  });
  return tableData;
};

export const account_name = (id) => {
  const accounts_name = getAccountNames();

  if (accounts_name) {
    return accounts_name[id] || "";
  } else {
    return id;
  }
}

export const location_name = (id) => {
  const locations_name = getLocationNames();
  if(locations_name){
    return locations_name[id] || "";
  } else {
    return '';
  }
}

export const handleQRScanPage = (type) => {
  const url = `/form-code?type=${type}`;
  window.open(url, '_blank');
}

export const calculateDaysLeft = (targetDate) => {
  const currentDate = new Date();
  const endDate = new Date(targetDate);

  const timeDiff = endDate - currentDate;
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};



export const capitalizeFirstLetter = (string) => {
  return string
  ?.split('_')
  ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
  ?.join(' ');
};

export const can_visit = (key_name) => {
  const featureConfigs = getFeatureConfigs();

  return !["_role_trial", "_role_enterprise"].includes(key_name) &&
    featureConfigs[key_name] === true;
};

export const calculateAgeByDos = (dob, dos) => {
  const parseDate = (date) => {
    const parsed = new Date(date);
    if (isNaN(parsed)) {
      return;
    }
    return parsed;
  };

  const birthDate = parseDate(dob);
  const dosDate = parseDate(dos);

  let age = dosDate?.getFullYear() - birthDate?.getFullYear();
  const monthDifference = dosDate?.getMonth() - birthDate?.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && dosDate?.getDate() < birthDate?.getDate())) {
    age--;
  }

  return age;
}

// unique identifiers for elements or keys.
export const uniqueKey = () => {
  return Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) + 1000000000;
}

export const formatRelativeTime = (utcDateString, timeZone = "America/New_York") => {
  const utcDate = new Date(utcDateString);

  const dateInTargetTimeZone = new Date(
    new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(utcDate)
  );

  const now = new Date();
  const nowInTargetTimeZone = new Date(
    new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(now)
  );

  const diffInMilliseconds = nowInTargetTimeZone - dateInTargetTimeZone;

  const seconds = Math.floor(diffInMilliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
};

export const formatTimeToEST = (utcDateString) => {
  const utcDate = new Date(utcDateString);

  const options = {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(utcDate);
}

export const formatToDateTime = (dateTime) => {
  if (!dateTime) return "";
  const date = new Date(dateTime);


  const options = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; 
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedDate} at ${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const formatTo12HourDateTime = (dateTime) => {
  if (!dateTime) return "";
  const date = new Date(dateTime);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const datePart = `${month}/${day}/${year}`;

  if (hours === 0 && minutes === 0) {
    return datePart;
  }

  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${datePart} ${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const time12HourFormat = (time) => {
  if (!time) return "";

  const [hour, minute] = time.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12; // 0 should be converted to 12

  const formattedMinute = String(minute).padStart(2, "0");

  return `${formattedHour}:${formattedMinute} ${ampm}`;
};

export const utcToUs = (utcDate) => {
  const date = new Date(utcDate);

  const options = {
    timeZone: 'America/New_York',
    hour12: true,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  const newYorkTime = date.toLocaleString('en-US', options);
  return newYorkTime;
}

// Debouncing function
export const debounce = (func, delay) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const insurance_name = (id) => {
  const insurances = getInsurancesList();

  if (insurances) {
    const insurance = insurances.find((insurance) => insurance.id === id);
    return insurance ? insurance.name : "";
  } else {
    return id;
  }
}
export const all_insurance_options = () => {
  return getInsurancesList();  
}

export const deep = (k,t = false) => {
  if (t) {
    return k
      .replace(/__TEN__/g, "0")
      .replace(/__ELEVEN__/g, "1")
      .replace(/__TWELVE__/g, "2")
      .replace(/__THIRTEEN__/g, "3")
      .replace(/__FOURTEEN__/g, "4")
      .replace(/__FIFTEEN__/g, "5");
  }
  return k
    .replace(/0/g, "__TEN__")
    .replace(/1/g, "__ELEVEN__")
    .replace(/2/g, "__TWELVE__")
    .replace(/3/g, "__THIRTEEN__")
    .replace(/4/g, "__FOURTEEN__")
    .replace(/5/g, "__FIFTEEN__");
}

export const copyToHtmlClipboard = (targetClass) => {
  const element = document.querySelector(`.${targetClass}`);
  if (!element) return;

  const style = document.createElement("style");
  style.innerHTML = `
    .${targetClass}._${targetClass} {
      color: green !important;
    }
  `;

  // Check for <ul> tags and unset their margin style
  const ulElements = element.querySelectorAll("ul");
  ulElements.forEach((ul) => {
    ul.style.margin = "unset";
  });

  const olElements = element.querySelectorAll("ol");
  olElements.forEach((ol) => {
    ol.style.margin = "unset";
  });

  const range = document.createRange();
  range.selectNode(element);

  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  try {
    document.execCommand("copy");
    document.head.appendChild(style);
    element.classList.add(`_${targetClass}`);
    notify("success", "Copied", 0.2);
    
    setTimeout(() => {
      element.classList.remove(`_${targetClass}`);
      document.head.removeChild(style);
    }, 100);
  } catch (err) {
    console.error("Unable to copy", err);
  }

  selection.removeAllRanges();
};

export const copyToHtmlClipboard2 = async (targetClass) => {
  const element = document.querySelector(`.${targetClass}`);
  if (!element) return;

  // Extract text content
  const textToCopy = element.innerText.trim();

  try {
    await navigator.clipboard.writeText(textToCopy);
    notify("success", "Copied", 0.2);
  } catch (err) {
    console.error("Unable to copy", err);
  }
};

export const isMobileDevice = () => {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const validatePassword = (pwd) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{12,}$/;
  return regex.test(pwd);
}
